import TablePanel from './TablePanel';

const findComponentData = (componentCfg, ctx) => {
  if (componentCfg.data) return componentCfg.data;
  return ctx.getChildConfigurationKeys(componentCfg).find(childCfg => findComponentData(childCfg, ctx));
};

const TablePanelInfo = {
  component: TablePanel,
  initializeComponent: (compCfg, configuration, ctx, childCtx) => {
    const mutComp = compCfg;
    const { selectedObjectType } = compCfg.configuration;
    if (!compCfg.configuration.selectedObjectType) {
      const dataCfg = findComponentData(compCfg.masterComponent);
      if (!dataCfg) {
        const { type } = mutComp.masterComponent;
        throw Error(`No data configuration found in top master view component of type ${type}`);
      }
      const schema = configuration.schemaService.getPathSchema(dataCfg[0].path);
      mutComp.configurationCfg.data = { type: schema.type, isArray: true };
    } else {
      // Data declares the schema
      mutComp.configuration.data = {
        type: selectedObjectType,
        properties: configuration.viewService.initalizeDataProperties({}, configuration.schemaService.getType(selectedObjectType)),
      };
    }
    const mutChildCtx = childCtx;
    mutChildCtx.type = configuration.schemaService.getType(compCfg.configuration.selectedObjectType);
  },
  getChildConfigurationKeys: () => {
    return ['overviewComponent', 'detailsComponent'];
  },
};

export default TablePanelInfo;
